import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faPlus, faPen, faFileExcel, faComments, faCogs,faCog, faEye, faDownload } from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../apiUrlConstant";
import DataTable, { createTheme, defaultThemes } from "react-data-table-component";
import datatableOptions from "../layout/datatableConstants";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { Modal, Button } from "react-bootstrap";
import CommentSection from "./CommentAdd";
import TaskAddComp from "./TaskAdd";
import UpdateStatus from "./UpdateLeadStatus";
import LeadStatusUpdate from "./LeadStatusUpdate";
import moment from "moment";
import { getUserCategory, numberFormat, capitalizeFirstLetter } from "../utils/index";
import Loader from "../Loader"; // Import the loader component
import ReportsColumnSelectionView from "./ReportColumn";
import Select from 'react-select'

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const DownloadButton = styled(Button)`
  margin-left: 0;
`;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="searchBtn"
    />
    <ClearButton type="button" onClick={onClear}>
      <FontAwesomeIcon icon={faSearch} />
    </ClearButton>
  </>
);

const LeadMasterTable = (props) => {
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Set initial loading to true
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [addSection, setAddSection] = useState('');
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [activeLeadId, setActiveLeadId] = useState();
  const [activeLeadStatus, setActiveLeadStatus] = useState('');
  const [activeLeadSubStatus, setActiveLeadSubStatus] = useState('');
  const [activeLeadSubStatusId, setActiveLeadSubStatusId] = useState('');
  const [activeCurrentStatus, setCurrentStatus] = useState('');
  const [gridColumns, setGridColumns] = useState([]);
  const [showColumn,setShowColumn] = useState(false);
  const [loadedColumns, setLoadedColumns] = useState([]);
  const [reportColumns, setReportColumns] = useState([]);

  // Define handleDownload function
  const handleDownload = async (stageData) => {
    try {
      var self = this;
      axios({
        method: "post",
        //url: `${apiUrl.apiUrl.url + '/leads/download-leads?stage='+stageData.type+'&sub_stage='+stageData.sub_type}`,
        url: `${apiUrl.apiUrl.url + '/leads/download-leads'}`,
        data: {'stage': stageData.type, 'sub_stage': stageData.sub_type, 'columns': reportColumns}
      }).then(function (response) {
        //console.log(response);
        window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response.data}`;
      });
    } catch (error) {
      console.error("Error downloading file: ", error);
    }
  };

  React.useEffect(() => {
    fetchLeads(1);
  }, [props.tablekey, filterText]);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <>
      {(data.length > 0 || filterText) && (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <FilterComponent
          onFilter={(e) => {
            setFilterText(e.target.value);
          }}
          onClear={handleClear}
          filterText={filterText}
        />
        {data.length > 0 && (
          <>
            <DownloadButton  onClick={()=>{handleDownload(props, reportColumns)}} className="download_button">
              Download
            </DownloadButton>

            <button  className="ms-3" onClick={()=>{handleGrid()}} ><FontAwesomeIcon icon={faCog} /></button>
          </>
        )}
      </div>
    )}
    </>
    );
  }, [filterText, resetPaginationToggle, props, data, reportColumns]);

  const fetchLeads = async (page) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${apiUrl.apiUrl.url}/leads/lists?stage=${props.type}&sub_stage=${props.sub_type}&page=${page}&per_page=${perPage}&delay=1&term=${filterText}`
      );
      
      // Set the data and total rows first
      setData(response.data.data);
      setTotalRows(response.data.total);
  
      // Then fetch the report columns using the same response context
      const reportColumnsResponse = await axios.get(
        `${apiUrl.apiUrl.url}/leads/fetch-report-columns?type=lead-listing`
      );

      handleMergeAction(reportColumnsResponse.data.gridColumns);
  
    } catch (error) {
      console.error("Error fetching data: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMergeAction = (column) => {
    console.log(column);
    setReportColumns(column);
    //console.log(reportColumns, 'Report column');
    const actionColumn = {
      name: "Action",
      grow: 1,
      sortable: false,
      cell: (record) => {
        return (
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                className="btnActions"
              >
                Action
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropup">
                <Dropdown.Item>
                  <span className="tableActionEdit">
                    <Link to={`/leads/edit/${record.id}`}>
                      <FontAwesomeIcon icon={faPen} /> Edit
                    </Link>
                  </span>
                </Dropdown.Item>
                <Dropdown.Item>
                  <span className="tableActionEdit">
                    <Link to={`/leads/view/${record.id}`}>
                      <FontAwesomeIcon icon={faEye} /> View
                    </Link>
                  </span>
                </Dropdown.Item>
                <Dropdown.Item onClick={(e) => {
                  handleModal(record.id, 'status', record);
                }}>
                  <div className="dropDownTagWIthIcon">
                    <span
                      title="Edit Stage"
                      onClick={(e) => {
                        handleModal(record.id, 'status', record);
                      }}
                      className="tableActionnewEdit"
                    >
                      <FontAwesomeIcon icon={faPen} /> Edit Stages
                    </span>
                  </div>
                </Dropdown.Item>
                <Dropdown.Item onClick={(e) => {
                  handleModal(record.id, 'lead_status', record);
                }}>
                  <div className="dropDownTagWIthIcon">
                    <span
                      title="Edit Stage"
                      onClick={(e) => {
                        handleModal(record.id, 'lead_status', record);
                      }}
                      className="tableActionnewEdit"
                    >
                      <FontAwesomeIcon icon={faPen} /> Edit Status
                    </span>
                  </div>
                </Dropdown.Item>
                <Dropdown.Item onClick={(e) => {
                  handleModal(record.id, 'task', record);
                }}>
                  <div className="dropDownTagWIthIcon">
                    <span
                      title="Add Task"
                      onClick={(e) => {
                        handleModal(record.id, 'task', record);
                      }}
                      className="tableActionnewEdit"
                    >
                      <FontAwesomeIcon icon={faPen} /> Add Task
                    </span>
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        );
      },
    };

    const updatedColumns = [...column, actionColumn];

    //console.log(updatedColumns);

    const modifiedColumns = updatedColumns.map(column => {
      if (column.selector === "lead_temperature") {
        return {
          ...column,
          sortable: true,
          cell: (record) => {
            if (record.lead_temperature === "hot") {
              return (
                <button className="btn btn-danger">
                  <i className="fas fa-fire"></i> Hot
                </button>
              );
            } else if (record.lead_temperature === "warm") {
              return (
                <button className="btn btn-warning">
                  <i className="fas fa-thermometer-half"></i> Warm
                </button>
              );
            } else if (record.lead_temperature === "cold") {
              return (
                <button className="btn btn-info">
                  <i className="fas fa-snowflake"></i> Cold
                </button>
              );
            } else {
              return (
                <button className="btn btn-secondary">
                  <i className="fas fa-question-circle"></i> {record.lead_temperature}
                </button>
              );
            }
          }
        };
      }

      if (column.selector === "title") {
        return {
          ...column,
          sortable: true, // Optional sorting
          cell: (record) => {
            return (
              <span title={record.title}>
                {record.title}
              </span>
            );
          }
        };
      }

      if (column.selector === "user_name") {
        return {
          ...column,
          sortable: true, // Optional sorting
          cell: (record) => {
            return (
              <span title={record.user_name}>
                {record.user_name}
              </span>
            );
          }
        };
      }

      return column; // Return the column unchanged if not lead_temperature
    });
    
    setGridColumns(modifiedColumns);
  };
  

  const handlePageChange = (page) => {
    fetchLeads(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${apiUrl.apiUrl.url}/leads/lists?stage=${props.type}&sub_stage=${props.sub_type}&page=${page}&per_page=${newPerPage}&delay=1&term=${filterText}`
      );
      setData(response.data.data);
      setPerPage(newPerPage);
    } catch (error) {
      console.error("Error fetching data: ", error);
    } finally {
      setLoading(false);
    }
  };

  function handleGrid() {
    console.log('You clicked submit.');
    setShowColumn(true);
  }

  const handleModal = (id, type, record) => {
    console.log(record);
    setActiveLeadId(id);
    setAddSection(type);
    setShowTaskModal(true);
    if (type === 'status') {
      //const record = data.find(d => d.id === id);
      setActiveLeadStatus(record.main_stage);
      setActiveLeadSubStatus(record.main_sub_stage);
      setActiveLeadSubStatusId(record.lm_lead_sub_stage_id);
    }else if(type === 'lead_status'){
      //const record = data.find(d => d.id === id);
      setCurrentStatus(record.lead_temperature);
    }
  };

  const closeTaskModel = () => {
    setShowTaskModal(false);
    fetchLeads(1);
    if (addSection == 'status' || addSection == 'lead_status') {
      props.onDataChange();
    }
  };

  const closeReportModel = () => {
    setShowColumn(false);
    // fetchLeads(1);
    // if (addSection == 'status' || addSection == 'lead_status') {
    //   props.onDataChange();
    // }
  };

  return (
    <div className="tableContainer" style={{ position: 'relative' }}>
      {loading && <Loader />}
      <DataTable
        key={props.tablekey}
        title=""
        columns={gridColumns}
        data={data}
        customStyles={datatableOptions.datatableOptions.customStyle}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        onChangePage={handlePageChange}
        paginationComponentOptions={datatableOptions.datatableOptions.paginationOptions}
      />

      <Modal className="customModalFroTaskAndComment" show={showTaskModal} onHide={() => setShowTaskModal(false)} backdrop="static" >
        <Modal.Header closeButton>
          <Modal.Title>{addSection === 'task' ? "Add Task" : addSection === 'comment' ? "Add Comment" : addSection=='lead_status'?'Update Status':"Update Stage"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {addSection === 'task' ? (
            <TaskAddComp closeModal={closeTaskModel} leadId={activeLeadId} />
          ) : addSection === 'comment' ? (
            <CommentSection closeModal={closeTaskModel} leadId={activeLeadId} />
          ) : addSection === 'lead_status' ? (
            <LeadStatusUpdate closeModal={closeTaskModel} leadId={activeLeadId} leadStatus = {activeCurrentStatus} />
          ):(
            <UpdateStatus closeModal={closeTaskModel} leadId={activeLeadId} stage={activeLeadStatus} sub_stage={activeLeadSubStatus}  sub_stage_id={activeLeadSubStatusId} />
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showColumn} onHide={() => setShowColumn(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Filter Columns</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <ReportsColumnSelectionView report='lead-listing' setGridColumns={setGridColumns} setLoadedColumns={setLoadedColumns} loadedColumns={loadedColumns} handleMergeAction={handleMergeAction}  handleClose={closeReportModel} />
        </Modal.Body>
      </Modal>

    </div>
  );
};




export default LeadMasterTable;
